import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UserPreviewHrNotificationEmailPayload } from 'api/actions/user-preview-hr-notification-email/user-preview-hr-notification-email-payload';
import { UserPreviewHrNotificationEmailPathParameters } from 'api/actions/user-preview-hr-notification-email/user-preview-hr-notification-email-path-parameters';
import { UserPreviewHrNotificationEmailResponse } from 'api/actions/user-preview-hr-notification-email/user-preview-hr-notification-email-response';

type UserPreviewHrNotificationEmailQueryParameters = Record<string, any>;

/**
 * The path of the UserPreviewHrNotificationEmail action.
 */
export const userPreviewHrNotificationEmailActionPath = new SweetPath<
  keyof UserPreviewHrNotificationEmailPathParameters
>('/api/user/notification-settings/{userId}/hr-email-preview', { path: '{param}' });

/**
 * Creates a contextualized UserPreviewHrNotificationEmail actions.
 */
export default function createUserPreviewHrNotificationEmailAction(axios: AxiosInstance) {
  return function userPreviewHrNotificationEmailAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: UserPreviewHrNotificationEmailPathParameters;
    query?: UserPreviewHrNotificationEmailQueryParameters;
    payload: UserPreviewHrNotificationEmailPayload;
  }) {
    const path = userPreviewHrNotificationEmailActionPath.insert(parameters);

    return axios.request<UserPreviewHrNotificationEmailResponse, UserPreviewHrNotificationEmailResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
